import type { Messages } from '../i18n/messages';

export const doraMessages: Messages = {
  // Entity tab title — the sole rendered surface for this tab (no separate
  // header in DoraServiceCard), same pattern as
  // modules/catalog/ArgocdEntityContent.tsx: resolved at module scope via
  // `translate()` since EntityContentBlueprint params are non-component code.
  // "DORA" is an industry term (DevOps Research and Assessment) — identical
  // en/fun in this short tab-label context.
  'dora.entityContent.title': { en: 'DORA', fun: 'DORA' },

  'dora.overviewPage.refreshTooltip': {
    en: 'Refreshes DORA metrics now. Auto refresh runs every 5 minutes while this page is visible.',
    fun: 'Yanks fresh DORA numbers right now. Auto-refreshes every 5 minutes while you keep this page open.',
  },
  'dora.overviewPage.windowAriaLabel': { en: 'Window', fun: 'Window' },
  'dora.overviewPage.window30d': { en: '30 days', fun: '30 days' },
  'dora.overviewPage.window90d': { en: '90 days', fun: '90 days' },
  'dora.overviewPage.loadError': {
    en: 'Could not load deployment data from the catalog.',
    fun: 'The catalog ghosted us on deployment data.',
  },

  'dora.serviceCard.loadError': {
    en: 'Could not load deployment data.',
    fun: 'Deployment data went missing.',
  },

  // DORA performance tier badges (Scorecard component).
  'dora.tier.elite': { en: 'Elite', fun: 'Elite' },
  'dora.tier.high': { en: 'High', fun: 'High five' },
  'dora.tier.medium': { en: 'Medium', fun: 'Meh-dium' },
  'dora.tier.low': { en: 'Low', fun: 'Yikes' },
  'dora.tier.na': { en: 'N/A', fun: 'N/A' },

  // Metric names — shared between the four Scorecard tiles and the matching
  // chart Card titles in DoraView (same slot, reused across both surfaces).
  'dora.scorecards.deploymentFrequency': {
    en: 'Deployment Frequency',
    fun: 'Ship Rate',
  },
  'dora.scorecards.leadTime': {
    en: 'Lead Time for Changes',
    fun: 'Commit-to-Ship Time',
  },
  'dora.scorecards.changeFailureRate': {
    en: 'Change Failure Rate',
    fun: 'Oops Rate',
  },
  'dora.scorecards.timeToRestore': {
    en: 'Time to Restore',
    fun: 'Bounce-Back Time',
  },
  'dora.scorecards.heuristicLabel': { en: 'heuristic', fun: 'guesstimate' },
  'dora.scorecards.leadTimeHeuristic': {
    en: 'commit→deploy time from GitHub; N/A without a GitHub session',
    fun: 'commit→deploy time from GitHub; no dice without a GitHub session',
  },
  'dora.scorecards.cfrHeuristic': {
    en: 'Heuristic: deploys superseded within 1h (rollback) or with a Degraded ArgoCD app',
    fun: 'Guesstimate: deploys superseded within 1h (rollback) or riding a Degraded ArgoCD app',
  },
  'dora.scorecards.mttrHeuristic': {
    en: 'Heuristic: time from a failed deploy to the next good deploy',
    fun: 'Guesstimate: time from a faceplant deploy to the next good one',
  },

  'dora.charts.noDeployments': {
    en: 'No deployments in window',
    fun: 'Crickets — no deploys in this window',
  },
  'dora.charts.loadingLeadTime': {
    en: 'Loading lead time…',
    fun: 'Crunching lead time…',
  },
  'dora.charts.leadTimeUnavailable': {
    en: 'Lead time unavailable — sign in to GitHub to enable commit→deploy timing',
    fun: 'Lead time is hiding — sign in to GitHub to unlock commit→deploy timing',
  },
  'dora.charts.noRestoreEvents': {
    en: 'No restore events in window',
    fun: 'Nothing broke in this window — no restores',
  },
  'dora.charts.leadTimeTooltipLabel': { en: 'Lead time', fun: 'Lead time' },
  'dora.charts.restoreTooltipLabel': {
    en: 'Time to restore',
    fun: 'Bounce-back time',
  },

  'dora.view.allEnvironments': { en: 'All environments', fun: 'Everywhere' },
  'dora.view.environmentLabel': { en: 'Environment', fun: 'Environment' },
  'dora.view.allServicesPlaceholder': {
    en: 'All services',
    fun: 'Every service',
  },
  'dora.view.columnService': { en: 'Service', fun: 'Service' },
  'dora.view.columnDeploys': { en: 'Deploys', fun: 'Ships' },
  'dora.view.columnLeadTime': { en: 'Lead time', fun: 'Lead time' },
  'dora.view.columnChangeFail': { en: 'Change fail %', fun: 'Oops %' },
  'dora.view.columnMttr': { en: 'MTTR', fun: 'MTTR' },
  'dora.view.byServiceCardTitle': { en: 'By service', fun: 'By service' },
  'dora.view.noServicesEmpty': {
    en: 'No services with deployments',
    fun: 'Nobody has shipped anything here',
  },
};
